/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tags: NonNullable<unknown> }} Transcript_Export_Tags_LabelInputs */



/**
* | output |
* | --- |
* | "TAGS: {tags}" |
*
* @param {Transcript_Export_Tags_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_tags_label = /** @type {((inputs: Transcript_Export_Tags_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Tags_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`TAGS: ${i?.tags}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`TAGS: ${i?.tags}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`TAG: ${i?.tags}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`ТЕГИ: ${i?.tags}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`ETIQUETAS: ${i?.tags}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`标签：${i?.tags}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`タグ: ${i?.tags}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`टैग: ${i?.tags}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`TAGS: ${i?.tags}`)
	return /** @type {LocalizedString} */ (`TAGS: ${i?.tags}`)
});